@let confirmationData = confirmationParams();
@if (confirmationData) {
  <div class="c-container">
    <div class="c-container__overlay">
      <div class="c-container__modal">
        <div class="c-container__header">
          <img src="../../../../assets/madero-logo.svg" alt="" srcset="" />
          <h1>reservas</h1>
          <hr />
        </div>
        <div class="c-container__content">
          @if (isConfirmed() !== null) {
            <mat-icon class="material-symbols-rounded c-container__content--icon">
              {{ isConfirmed() === true ? 'task_alt' : 'cancel' }}
            </mat-icon>
          }
          <h1>
            Olá, <b>{{ confirmationData.client }}</b
            >!
          </h1>
          @if (isConfirmed() === null) {
            @if (errorService() === true) {
              <h1>Ocorreu um erro na solicitação!</h1>
              <h3>Entre em contato com o restaurante.</h3>
            } @else {
              <h1>Aguarde enquanto realizamos sua solicitação...</h1>
              <div class="c-spinner">
                <mat-spinner></mat-spinner>
              </div>
            }
          } @else if (isConfirmed() === true) {
            <h3 class="c-container__content--title">
              <span>Sua reserva foi <b>confirmada</b>!</span>
            </h3>
          } @else if (isConfirmed() === false) {
            <h3 class="c-container__content--title">
              <span>Sua reserva foi <b>cancelada</b>!</span>
            </h3>
          }
          @if (isConfirmed() !== null) {
            <div class="c-card-details">
              <p>{{ isConfirmed() === true ? 'Estamos te esperando no' : 'Detalhes da reserva' }}</p>
              <h2>{{ confirmationData.branchName || 'Não há dados do restaurante' }}</h2>
              <div class="c-card-details__date-hour">
                <h4>
                  <mat-icon class="material-symbols-rounded c-card-details__date-hour--icon">
                    calendar_today
                  </mat-icon>
                  <span>{{ (confirmationData.date | date: 'dd/MM/yy') || '--/--/--' }}</span>
                </h4>
                <h4>
                  <mat-icon class="material-symbols-rounded c-card-details__date-hour--icon">
                    access_time
                  </mat-icon>
                  <span>{{ confirmationData.hour || '--:--' }}</span>
                </h4>
              </div>
              Reserva para <b>{{ confirmationData.quantity }}</b> pessoa(s) no <b>Salão Principal</b>
            </div>
            <h2 class="tolerance">
              @if (isConfirmed() === false) {
                Esperamos te ver na próxima!
              } @else if (confirmationData.tolerance) {
                <mat-icon class="material-symbols-rounded c-card-details__date-hour--icon">
                  warning
                </mat-icon>
                O tempo de tolerância é de {{ confirmationData.tolerance }} minutos
              }
            </h2>
          }
        </div>
      </div>
    </div>
  </div>
}
